<template>
    <f-dialog
        v-model      = "show"
        :title       = "title"
        :width       = "600"
        :show-header = "false"
        :show-delete = "false"

        store-label  = "Zuordnen"
        @store       = "onAssign"
        @cancel      = "onCancel"
    >
        <template v-slot:content>
            <div style="width: calc(100% + 10px)">
                <c-card-iterator
                    v-if           = "contacts"
                    :items         = "contacts"
                    :item-height   = "50"
                    :label         = "title"
                    :filter        = "contactFilter"
                    class          = "w-100"
                    :height        = "480"
                    ref            = "iterator"
                >
                    <template v-slot:filter>
                        <v-row class="no-frame">
                            <v-col class="no-frame">
                                <f-enum-autocomplete
                                    v-if       = "onsite"
                                    v-model    = "onSitecompany"
                                    label      = "Facility Manager"
                                    module     = "msd"
                                    type       = "facilitymanager"
                                    :clearable = "true"
                                    @change    = "onCompany"
                                />
                                <f-enum-autocomplete
                                    v-if       = "zus"
                                    v-model    = "zuscompany"
                                    label      = "ZÜS"
                                    module     = "msd"
                                    type       = "zus"
                                    :clearable = "true"
                                    @change    = "onCompany"
                                />
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:card="{ item }">
                        <c-list-card
                            :height      = "55"
                            :background  = "item.background"
                            :edit        = "false"
                            border-width = "pa-2 pt-1"
                            :key         = "item.id + item.selected"
                            @selected    = "onSelected(item)"
                        >
                            <template v-slot:title>
                                <div class="v-flex w-100">
                                    <div class="contact-data">
                                       {{ item.firstname ? (item.firstname + ' ' + item.name) : item.name}}
                                    </div>
                                    <v-spacer />
                                    <div class="contact-data">
                                        {{ item.email }}
                                    </div>
                                </div>
                            </template>
                            <template v-slot:body>
                                <div class="v-flex">
                                    <div class="contact-data">
                                        {{ roles (item) }}
                                    </div>
                                    <v-spacer />
                                    <div class="contact-data">
                                        {{ phones (item) }}
                                    </div>
                                </div>
                            </template>
                        </c-list-card>
                    </template>
                </c-card-iterator>
            </div>
        </template>
    </f-dialog>
</template>

<script>

import Contact           from "@/modules/msd/company/contact/service/Contact";
import Company           from "@/modules/msd/company/common/service/Company";
import FDialog           from "@/modules/core/components/utils/FDialog";
import CCardIterator     from "@/modules/core/components/utils/CCardIterator";
import CListCard         from "@/modules/core/components/utils/CListCard";
import FEnumAutocomplete from "@/modules/core/components/utils/FEnumAutocomplete";

export default {
    name: "DSiteContactAssignment",

    components: {
        FEnumAutocomplete,
        CListCard,
        CCardIterator,
        FDialog
    },

    props: {
        value: {

        },

        label: {

        },

        company: {

        },

        companyRole: {

        },

        selected: {

        },

        onsite: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            }
        },
        zus: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            }
        },
    },

    data: () => ({
        show: false,
        searchtext: null,
        contacts: [],
        onSitecompany: null,
        zuscompany: null,
    }),

    computed: {
        title () {
            if (!this.company) {
                return this.label + " zuordnen";
            }

            return this.company.name + " - " + this.label + " zuordnen";
        },

    },

    mounted() {
        this.show = this.value;
        this.load();
    },

    watch: {
        value () {
            this.show = this.value;
            this.load();
        }
    },

    methods: {
        load () {
            if (!this.show) {
                return;
            }

            const filter = {
                active: true,
                siteAssignmentTypeId: 1,
            };

            let companyId = this.company ? this.company.id : null;
            if (this.onsite && this.onSitecompany) {
                companyId = this.onSitecompany.id
            }

            if (this.zus && this.zuscompany) {
                companyId = this.zuscompany.id
            }

            if (!companyId) {
                return;
            }

            Company.contacts(companyId, filter, (data) => {
                data.forEach(contact => {
                    contact.background = "white";
                });

                let unselected = data.filter (contact => !this.selected.find(s => s.id === contact.id));
                unselected = unselected.filter(contact => contact.roles.find(role => role.companyRole.id === this.companyRole));
                console.log("role", this.companyRole, unselected);

                this.contacts = unselected;
            });
        },

        onCompany () {
            this.load();
        },

        onAssign () {
            const selected = this.contacts.filter (contact => contact.selected);
            this.$emit("assign", selected);
            this.$emit("input", false);
        },

        onCancel () {
            this.$emit("input", false);
        },

        contactFilter (item, text) {
            return Contact.filter(item, text)
        },

        onSelected (item) {
            item.selected = !item.selected;
            if (item.selected) {
                item.background = "selected-background"
            } else {
                item.background = "white"
            }
        },

        roles (item) {
            if (!item.roles) {
                return null;
            }

            let result = "";
            item.roles.forEach((role, index) => {
                result += index === item.roles.length-1 ? role.name  : role.name + '; ';
            })

            return result;
        },

        phones (item) {
            if (!item.phonenumbers) {
                return null;
            }

            let result = "";
            item.phonenumbers.forEach((phone, index) => {
                result += index === item.phonenumbers.length-1 ? phone.number  :phone.number + '; ';
            })

            return result;
        },
    }
}
</script>

<style scoped>

::v-deep .selected-background {
    background-color: aliceblue;
}

.contact-data {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 50%;
}

</style>